export const validacaoDataPagamentoAte = (
        dataPagamentoAteValor,
        instanciaComponenteAtual
    ) => {
        if (
            instanciaComponenteAtual.dataPagamentoDe != null &&
            dataPagamentoAteValor == null
        )
            return false

        if (
            instanciaComponenteAtual.dataPagamentoDe == null &&
            dataPagamentoAteValor == null
        )
            return true

        const resultadoValidacao =
            instanciaComponenteAtual.$moment
                .utc(instanciaComponenteAtual.dataPagamentoDe, 'DD/MM/YYYY')
                .isBefore(
                    instanciaComponenteAtual.$moment.utc(
                        dataPagamentoAteValor,
                        'DD/MM/YYYY'
                    )
                ) ||
            instanciaComponenteAtual.$moment
                .utc(instanciaComponenteAtual.dataPagamentoDe, 'DD/MM/YYYY')
                .isSame(
                    instanciaComponenteAtual.$moment.utc(
                        dataPagamentoAteValor,
                        'DD/MM/YYYY'
                    )
                )

        return resultadoValidacao
    }
